import { useSearchParams } from "react-router-dom";

const getSelectedValues = (value) =>
  new Set(
    (value ?? "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
  );

const useDashboardExplorerCriteria = ({
  typeCriteriaKey,
  statusCriteriaKey,
}) => {
  const [searchParams] = useSearchParams();
  const typeId = searchParams.get("typeId");
  const statusId = searchParams.get("statusId");
  const hasDashboardCriteria = Boolean(typeId || statusId);

  if (!hasDashboardCriteria) {
    return {};
  }

  return {
    initialCriteriaSelectionMap: {
      ...(typeId
        ? { [typeCriteriaKey]: getSelectedValues(typeId) }
        : {}),
      ...(statusId
        ? { [statusCriteriaKey]: getSelectedValues(statusId) }
        : {}),
    },
    skipSavedCriteria: true,
    criteriaSearchParamMap: {
      [typeCriteriaKey]: "typeId",
      [statusCriteriaKey]: "statusId",
    },
  };
};

export default useDashboardExplorerCriteria;
